// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header","toolbar":"toolbar","back-arrow":"back-arrow","form-actions":"form-actions","md-errors-spacer":"md-errors-spacer"};